// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1u_tb","author":"Table_author__1HD0s","authorImage":"Table_authorImage__1fIc4","unreadRow":"Table_unreadRow__1hl5T"};